import { styled } from '@mui/material';

export const EMOJI_PICKER_WIDTH = 292;

export const Wrapper = styled('div')({
  position: 'relative',
});

export const EmojiButton = styled('button')(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  border: `1px solid ${theme.palette.novotalk.$inputBorderColor}`,
  background: theme.palette.novotalk.$backgroundColor,
  cursor: 'pointer',
  fontSize: 18,
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    borderColor: theme.palette.novotalk.$activeColor,
  },
}));

export const EmojiPicker = styled('div')(({ theme }) => ({
  position: 'fixed',
  zIndex: 1400,
  width: EMOJI_PICKER_WIDTH,
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.novotalk.$inputBorderColor}`,
  background: theme.palette.novotalk.$backgroundColor,
  borderRadius: 8,
  padding: 8,
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.12)',
}));

export const EmojiSearchInput = styled('input')(({ theme }) => ({
  width: '100%',
  height: 34,
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.novotalk.$inputBorderColor}`,
  borderRadius: 6,
  padding: '0 10px',
  marginBottom: 8,
  outline: 'none',
  fontSize: 13,
  lineHeight: '20px',
  '&:focus': {
    borderColor: theme.palette.novotalk.$activeColor,
  },
}));

export const EmojiControlsRow = styled('div')({
  width: '100%',
  marginBottom: 8,
});

export const EmojiTabs = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  width: '100%',
  overflow: 'visible',
  paddingBottom: 2,
});

export const EmojiTab = styled('button')(({ theme, isActive }) => ({
  border: 'none',
  background: isActive ? 'rgba(0, 0, 0, 0.06)' : 'transparent',
  borderBottom: `2px solid ${isActive ? theme.palette.novotalk.$activeColor : 'transparent'}`,
  borderRadius: 0,
  height: 30,
  width: 32,
  minWidth: 32,
  maxWidth: 32,
  padding: 0,
  cursor: 'pointer',
  color: theme.palette.novotalk.$textColorDarkBlue,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.05)',
  },
}));

export const EmojiTabIcon = styled('span')({
  fontSize: 14,
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const EmojiOverflowMenu = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 34,
  right: 0,
  width: 170,
  maxHeight: 220,
  overflowY: 'auto',
  background: theme.palette.novotalk.$backgroundColor,
  border: `1px solid ${theme.palette.novotalk.$inputBorderColor}`,
  borderRadius: 8,
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.14)',
  padding: 6,
  zIndex: 2,
}));

export const EmojiOverflowMenuItem = styled('button')(({ theme, isActive }) => ({
  width: '100%',
  height: 30,
  border: 'none',
  borderRadius: 6,
  background: isActive ? 'rgba(0, 0, 0, 0.06)' : 'transparent',
  color: theme.palette.novotalk.$textColorDarkBlue,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '0 8px',
  textAlign: 'left',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.05)',
  },
}));

export const ToneSelector = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  gap: 4,
  marginTop: 8,
  paddingTop: 8,
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
});

export const ToneButton = styled('button')(({ theme, isActive }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  border: `1px solid ${isActive ? theme.palette.novotalk.$activeColor : theme.palette.novotalk.$inputBorderColor}`,
  background: isActive ? 'rgba(0, 0, 0, 0.06)' : 'transparent',
  cursor: 'pointer',
  fontSize: 14,
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
}));

export const EmojiPickerScroll = styled('div')({
  maxHeight: 320,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: 8,
  boxSizing: 'border-box',
  scrollbarGutter: 'stable',
});

export const EmojiSectionTitle = styled('div')(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  lineHeight: '16px',
  margin: '4px 0 8px 0',
  color: theme.palette.novotalk.$textColorDarkBlue,
  textTransform: 'uppercase',
}));

export const EmojiGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 32px)',
  justifyContent: 'start',
  columnGap: 4,
  rowGap: 6,
  width: '100%',
  boxSizing: 'border-box',
  marginBottom: 12,
});

export const EmojiItem = styled('button')(({ theme }) => ({
  width: 32,
  height: 32,
  padding: 0,
  boxSizing: 'border-box',
  border: '1px solid transparent',
  borderRadius: 6,
  background: 'transparent',
  cursor: 'pointer',
  fontSize: 18,
  lineHeight: 1,
  '&:hover': {
    borderColor: theme.palette.novotalk.$activeColor,
    background: 'rgba(0, 0, 0, 0.04)',
  },
}));
